import React, { useState } from "react";
import { Button, Card } from "antd";
import HeaderComponent from "components/card/HeaderComponent";
import HeaderModal from "components/modal/HeaderModal";
import { Send, Target, CircleCheck, Star, TrendingUp, Users, Sparkles, Lightbulb, Brain, Trophy, Gift } from "lucide-react";
import AwardeeSelector from "./AwardeeSelector";

const AwardCategoryCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const openModal = (category) => {
    setSelectedCategory(category);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCategory(null);
  };

  const categories = [
    {
      id: 1,
      icon: Target,
      title: "Delivery Excellence",
      description: "Consistently exceeding expectations, delivering on time and to a high standard",
      credits: 500,
    },
    {
      id: 2,
      icon: CircleCheck,
      title: "Project Success",
      description: "Exceptional contribution to the completion of a major project or milestone",
      credits: 750,
    },
    {
      id: 3,
      icon: Star,
      title: "Quality & Accuracy",
      description: "Outstanding attention to detail or improvement in quality metrics",
      credits: 400,
    },
    {
      id: 4,
      icon: TrendingUp,
      title: "Productivity & Efficiency",
      description: "Significantly improving processes, reducing costs, or saving time",
      credits: 600,
    },
    {
      id: 5,
      icon: Users,
      title: "Team Player Award",
      description: "Going above and beyond to support peers or cross-functional teams",
      credits: 450,
    },
    {
      id: 6,
      icon: Sparkles,
      title: "Collaboration & Knowledge",
      description: "Fostering cooperation, mentoring others, or sharing expertise",
      credits: 500,
    },
    {
      id: 7,
      icon: Trophy,
      title: "Positive Workplace Culture",
      description: "Promoting morale, inclusion, and a supportive environment",
      credits: 400,
    },
    {
      id: 8,
      icon: Lightbulb,
      title: "Innovation & Creativity",
      description: "Proposing or implementing new ideas that create measurable value",
      credits: 700,
    },
    {
      id: 9,
      icon: Brain,
      title: "Technology & AI Adoption",
      description: "Leading or contributing to effective use of new digital or AI tools",
      credits: 650,
    },

  ];

  return (
    <HeaderComponent
      title="Award Categories"
      titleClass="text-[16px] font-medium"
      description="Select a category to award gift credits to your team members"
      descriptionClass="text-sm"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-h-[80vh] overflow-y-auto">
        {categories.map((item) => {
          const Icon = item.icon;
          return (
            <Card
              key={item.id}
              onClick={() => openModal(item)}
              className={`card-theme ${item.title
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")  
                .replace(/^-+|-+$/g, "") 
              } cursor-pointer hover:shadow-lg transition-all`}
            >
              <div className="space-y-4">
                <div className="flex flex-col items-start gap-3">
                  <div className="inline-flex items-start justify-between w-full">
                    <div className="icon-style p-3 text-white">
                      <Icon className="h-6 w-6" />
                    </div>
                    <div>
                      <span className="border status-color font-medium rounded-xl px-1 py-0.5 text-xs">{item.credits} credits</span>
                    </div>
                  </div>


                  <h4 className="card-text">{item.title}</h4>
                  <p className="text-[13px] text-muted-foreground">{item.description}</p>
                </div>
                <button className={`!bg-gradient-to-r h-8 rounded-2xl w-full icon-style text-white inline-flex items-center justify-center font-semibold gap-3`}>
                  <Send className="h-4 w-4" />
                  Award Credits
                </button>
              </div>
            </Card>
          );
        })}
      </div>

      {isModalOpen && selectedCategory && (
        <HeaderModal
          open={isModalOpen}
          onClose={closeModal}
          title={`Award for ${selectedCategory.title}`}
          titleClass="text-lg font-semibold"
          labelIcon={
            <div className={`card-theme ${selectedCategory.title
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")  
                .replace(/^-+|-+$/g, "") } invisible`}>
              <div className="icon-style p-2 text-white visible">
                {selectedCategory.icon && React.createElement(selectedCategory.icon, { className: "h-5 w-5" })}
              </div>
            </div>
          }
          description={selectedCategory.description}
          descriptionClass="text-sm"
          bgcolor="white"
          width={550}
          footer={
            <div className="p-4 flex justify-end gap-2">
              <Button
                className="inline-flex items-center justify-center gap-2 rounded-xl text-sm text-gray-800 h-9 px-4"
                onClick={closeModal}
              >
                Cancel
              </Button>
              <div className={`card-theme ${selectedCategory.title.toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")  
                .replace(/^-+|-+$/g, "") } invisible`}>
                <Button
                  icon={<Gift size={16} />}
                  className="!bg-gradient-to-r icon-style inline-flex items-center justify-center visible text-white p-4 h-9 font-medium"
                >
                  Award Credits
                </Button>
              </div>
            </div>
          }
        >
          <AwardeeSelector creditsAmount={selectedCategory.credits} 
          
              category={selectedCategory.title.toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")  
                .replace(/^-+|-+$/g, "") } />
        </HeaderModal>
      )}
    </HeaderComponent>
  );
};

export default AwardCategoryCard;
